import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Box from 'components/Box';
import ActionButtonMenu from 'components/ActionButtonMenu';
import { BadgeImageDetailsModal } from 'screens/ContentEditorModals';
import DeletionConfirmationModal from './DeletionConfirmationModal';
function ActionMenu(_ref) {
  var badgeImage = _ref.badgeImage,
    titleId = _ref.titleId,
    onDelete = _ref.onDelete,
    parentPlaylistId = _ref.parentPlaylistId;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDeleteConfirmationModalVisible = _useState2[0],
    setIsDeleteConfirmationModalVisible = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isBadgeImageModalVisible = _useState4[0],
    setIsBadgeImageModalVisible = _useState4[1];
  var menuId = "".concat(badgeImage.imageId, "-badge-image-menu");
  var editMenuItem = {
    value: t('actions_edit'),
    icon: 'edit',
    onSelect: function onSelect() {
      return setIsBadgeImageModalVisible(true);
    }
  };
  var menuItems = onDelete ? [editMenuItem, {
    value: t('actions_delete'),
    icon: 'trash',
    onSelect: function onSelect() {
      return setIsDeleteConfirmationModalVisible(true);
    }
  }] : [editMenuItem];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    position: "absolute",
    top: "0",
    right: "0",
    z: "raised"
  }, /*#__PURE__*/React.createElement(ActionButtonMenu, {
    items: menuItems,
    id: menuId,
    titleId: titleId
  })), isDeleteConfirmationModalVisible && onDelete && /*#__PURE__*/React.createElement(DeletionConfirmationModal, {
    badgeImageId: badgeImage.imageId,
    onDelete: onDelete,
    onClose: function onClose() {
      return setIsDeleteConfirmationModalVisible(false);
    },
    parentPlaylistId: parentPlaylistId
  }), isBadgeImageModalVisible && /*#__PURE__*/React.createElement(BadgeImageDetailsModal, {
    initialBadgeImage: badgeImage,
    onClose: function onClose() {
      return setIsBadgeImageModalVisible(false);
    },
    parentPlaylistId: parentPlaylistId
  }));
}
export default ActionMenu;